import type { FAQ } from '@ps/web-martech-cms-types';
import React, { useState } from 'react';

import PanelItem from '../CMSPanel/PanelItem';

import styles from './CMSFAQ.scss';

const CMSFAQ: React.FC<FAQ> = ({ items }) => {
  const [expandedItems, setExpandedItems] = useState<boolean[]>(items.map(() => false));
  const onClick = (index: number) => {
    setExpandedItems((items) => [
      ...items.slice(0, index),
      !items[index],
      ...items.slice(index + 1)
    ]);
  };
  return items.length ? (
    <div className={styles.faq}>
      {items.map((item, index) => {
        const { question, answer } = item.item;
        return (
          <PanelItem
            key={index}
            body={answer}
            expandedTitle={question}
            collapsedTitle={question}
            expanded={expandedItems[index]}
            onClick={() => onClick(index)}
          />
        );
      })}
    </div>
  ) : null;
};

export default CMSFAQ;
